export const summaryStatCardGridRootClass = "grid grid-cols-1 gap-4 md:grid-cols-2 mb-0";
